<template>
	<v-app>
		<div class="stamp-register">
			<ManagingSection header="회원 기본 정보" :columnCount="4">
				<ManagingBox title="회원번호">{{ idRegister }}</ManagingBox>
				<ManagingBox title="닉네임">
					<router-link
						:to="`/register/register-info/${idRegister}`"
						target="_blank"
						class="link"
						>{{ registerInfo.nickName }}</router-link
					>
				</ManagingBox>
				<ManagingBox title="성별">{{ genderName }}</ManagingBox>
				<ManagingBox title="나이">{{ registerInfo.age }}</ManagingBox>
				<ManagingBox title="회원등급">
					<span
						:style="{ color: gradeObj.color }"
						v-text="gradeObj.name"
					/>
				</ManagingBox>
				<ManagingBox title="피부타입">{{ skinTypeName }}</ManagingBox>
				<ManagingBox title="회원상태">{{
					registerInfo.isActivity ? '활성' : '비활성'
				}}</ManagingBox>
				<ManagingBox title="블라인드여부">{{
					Util.getBlindLabel(registerInfo.isBlind)
				}}</ManagingBox>
				<ManagingBox title="휴대폰인증">
					<PhoneNumber :tel="registerInfo.userTel" />
					<IsCertification
						:isCertification="registerInfo.isCertification"
					/>
				</ManagingBox>
				<ManagingBox title="주소">{{
					registerInfo.address
				}}</ManagingBox>
			</ManagingSection>
			<ManagingSection header="회원 참여 정보" :columnCount="4">
				<ManagingBox title="이벤트 기간"
					>{{ Util.date(stampInfo.start_on) }} ~
					{{ Util.date(stampInfo.finish_on) }}</ManagingBox
				>
				<ManagingBox title="이벤트 번호">{{ idStamp }}</ManagingBox>
				<ManagingBox title="이벤트명">{{
					stampInfo.title
				}}</ManagingBox>
				<ManagingBox title="당첨여부">{{
					stampInfo.winTitle
				}}</ManagingBox>
				<ManagingBox title="누적출석">{{ stampInfo.cnt }}</ManagingBox>
				<ManagingBox title="일반출석">{{
					stampInfo.normalCnt
				}}</ManagingBox>
				<ManagingBox title="대체출석">{{
					stampInfo.subCnt
				}}</ManagingBox>
				<ManagingBox title="댓글">
					<button
						:disabled="!stampInfo.commentCnt"
						class="btn"
						v-text="stampInfo.commentCnt"
						@click="openCommentModal"
					/>
				</ManagingBox>
			</ManagingSection>
			<ManagingSection header="회원 기본 정보" :isTabe="true">
				<table class="table-main stamp-register__table">
					<thead>
						<tr>
							<th
								v-for="th in thList"
								:key="th.id"
								:class="`stamp-register__th-${th.id}`"
								v-text="th.text"
							/>
						</tr>
					</thead>
					<tbody v-if="dateList">
						<tr v-for="item in dateList" :key="item.date">
							<td v-text="item.date" />
							<td v-text="item.stampedAt" />
							<td>
								<p
									class="stamp-register__review-date-column-conts"
								>
									{{ item.reviewDate }}
								</p>
								<v-menu
									v-if="item.reviewList"
									offset-y
									open-on-hover
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											small
											color="error"
											depressed
											text
											v-bind="attrs"
											v-on="on"
											v-text="'**중복미션**'"
										/>
									</template>
									<v-simple-table>
										<template v-slot:default>
											<tbody>
												<tr
													v-for="(
														reviewItem, idx
													) in item.reviewList"
													:key="idx"
												>
													<td>
														{{
															moment
																.utc(
																	reviewItem.created_at
																)
																.format(
																	'MM-DD HH:mm'
																)
														}}
													</td>
													<td>
														{{
															reviewItem.category_title
														}}
													</td>
													<td>
														{{
															reviewItem.brandTitle
														}}
													</td>
													<td>
														{{
															reviewItem.productTitle
														}}
													</td>
												</tr>
											</tbody>
										</template>
									</v-simple-table>
								</v-menu>
							</td>
							<td v-text="item.category_title" />
							<td v-text="item.brandTitle" />
							<td>
								<router-link
									v-if="item.review_id"
									:to="`/review/${item.review_id}`"
									target="_blank"
									class="link"
									>{{ item.productTitle }}</router-link
								>
							</td>
							<td>
								<button
									:disabled="!item.commentCnt"
									class="btn"
									v-text="item.commentCnt || 0"
									@click="openCommentModal(item.date)"
								/>
							</td>
							<td>
								<span
									v-if="item.is_force_stamp"
									class="font-red"
									v-text="'강제 출석'"
								/>
								<button
									v-else-if="item.canForceStamp"
									class="btn red"
									v-text="'출석 처리'"
									@click="forceStamp(item.date)"
								/>
							</td>
							<td v-text="item.admin_nickName" />
							<td>
								<template v-if="item.createdAt">
									{{ item.createdAt }}
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingSection>
		</div>
	</v-app>
</template>
<script>
	import isEmpty from 'lodash/isEmpty';
	import moment from 'moment';
	import Util from '@/lib/Util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PhoneNumber from '@/components/Atoms/PhoneNumber.vue';
	import IsCertification from '@/components/Atoms/IsCertification.vue';

	export default {
		name: 'EventStampRegister',
		components: {
			ManagingSection,
			ManagingBox,
			PhoneNumber,
			IsCertification,
		},
		data() {
			return {
				moment,
				idStamp: this.$route.params.idStamp,
				idRegister: this.$route.params.idRegister,
				registerInfo: {},
				stampInfo: {},
				thList: [
					{ id: 'date', text: '날짜' },
					{ id: 'time--stamp', text: '일반출석일시' },
					{ id: 'time--mission', text: '리뷰미션일시' },
					{ id: 'cate', text: '리뷰카테고리' },
					{ id: 'brand', text: '리뷰브랜드' },
					{ id: 'pdt', text: '리뷰제품' },
					{ id: 'comment', text: '댓글' },
					{ id: 'stamp-button', text: '강제출석처리' },
					{ id: 'admin', text: '처리자' },
					{ id: 'time--force', text: '처리일시' },
				],
				dateList: null,
			};
		},
		computed: {
			genderName() {
				return this.$store.getters.getItemById(
					'gender',
					this.registerInfo && this.registerInfo.gender
				)?.name;
			},
			gradeObj() {
				return (
					this.$store.state.filter.gradeList.find(
						item =>
							item.id ===
							(this.registerInfo && this.registerInfo.grade)
					) || {}
				);
			},
			skinTypeName() {
				return this.$store.getters.getItemById(
					'skinType',
					this.registerInfo && this.registerInfo.skinType
				)?.name;
			},
		},
		methods: {
			async setData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/v3/api/stamp/${this.idStamp}/register/${this.idRegister}`
					);
					this.registerInfo = data.register_info[0];
					this.stampInfo = data.register_stamp_info[0];
					const dailyList = data.register_stamp_daily;
					const lastDateObj = moment(this.stampInfo.start_on).endOf(
						'month'
					);
					const maxDay = lastDateObj.daysInMonth();
					const dateList = [];
					for (let offset = 0; offset < maxDay; offset++) {
						const date = moment(lastDateObj)
							.add(-offset, 'd')
							.format('YYYY-MM-DD');
						const today = moment().format('YYYY-MM-DD');
						if (date <= today) {
							const dateArr =
								dailyList.filter(
									item =>
										moment(item.stamped_at).format(
											'YYYY-MM-DD'
										) === date
								) || [];
							const dateObj = dateArr[0] || {};
							if (isEmpty(dateObj)) {
								dateObj.canForceStamp = true;
							} else {
								dateObj.stampedAt = Util.dateFormat(
									dateObj.stamped_at,
									'MM-DD HH:mm'
								);
								dateObj.reviewDate =
									dateObj.review_date &&
									moment
										.utc(dateObj.review_date)
										.format('MM-DD HH:mm');
								dateObj.canForceStamp =
									!dateObj.stamped_at && !dateObj.review_date;
								dateObj.createdAt =
									dateObj.admin_nickName && dateObj.created_at
										? Util.dateFormat(
												dateObj.created_at,
												'MM-DD HH:mm'
											)
										: null;
								if (dateArr.length > 1)
									dateObj.reviewList = dateArr;
							}
							dateObj.date = date;
							dateList.push(dateObj);
						}
					}
					if (dateList.length) this.dateList = dateList;
				} catch (e) {
					console.error(e);
					alert('회원상세데이터 로드 실패!');
				}
			},
			openCommentModal(date) {
				if (typeof date !== 'string') date = null;
				this.$store.commit('modal/toggleModal', {
					id: 'StampCommentList',
					params: {
						idRegister: this.idRegister,
						date,
					},
				});
			},
			async forceStamp(date) {
				try {
					await this.$axiosAdmin2.post(
						`/v3/api/stamp/${this.idStamp}/register/${this.idRegister}/${date}`
					);
					this.setData();
				} catch (e) {
					console.error(e);
					alert(e);
				}
			},
		},
		mounted() {
			this.setData();
		},
	};
</script>
<style lang="scss" scoped>
	.stamp-register {
		width: 100%;

		&__review-date-column-conts {
			margin-bottom: 0;
		}
	}
</style>
